import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=7170a7a1&scoped=true&"
import script from "./EmailDetail.vue?vue&type=script&lang=ts&"
export * from "./EmailDetail.vue?vue&type=script&lang=ts&"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=7170a7a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170a7a1",
  null
  
)

component.options.__file = "EmailDetail.vue"
export default component.exports